module.exports = __webpack_public_path__ + "img/liam.01dab460.png";